document.addEventListener('DOMContentLoaded',function(){
  var ribbon=document.querySelector('.preview-ribbon');
  var text=document.querySelector('[data-text]');
  var width=document.querySelector('[data-width]');
  var position=document.querySelector('select[name="properties[Logoposition]"]');
  var symbol=document.querySelector('[data-symbol]');
  var font=document.querySelector('[data-font]');
  if(!ribbon||!text)return;
  function scale(){
    var isThermo=location.pathname.includes('thermosatin-100-mm-bedruckt');
    var widthValue=width&&width.selectedOptions&&width.selectedOptions[0]&&width.selectedOptions[0].dataset.width?width.selectedOptions[0].dataset.width:(width&&width.value?width.value:'10');
    var mm=isThermo?100:parseInt(widthValue,10);
    var sizes={10:28,15:36,25:50,38:66,100:72};
    var heights={10:34,15:44,25:60,38:78,100:116};
    // Leave extra vertical space for typefaces with tall ascenders/descenders.
    // The preview text is intentionally rendered 10% smaller; Thermosatin uses
    // an additional reduced base size so wide letterforms keep enough space.
    var base=(sizes[mm]||36)*.9;
    var bandHeight=heights[mm]||44;
    ribbon.style.display='flex';
    ribbon.style.alignItems='center';
    ribbon.style.justifyContent='center';
    ribbon.style.gap='.18em';
    ribbon.style.whiteSpace='nowrap';
    ribbon.style.lineHeight='1';
    ribbon.style.minHeight=bandHeight+'px';
    ribbon.style.paddingBlock=Math.max(3,(bandHeight-base)/2)+'px';
    ribbon.style.fontSize=base+'px';
    requestAnimationFrame(function(){
      var available=Math.max(180,ribbon.clientWidth-64);
      if(ribbon.scrollWidth>ribbon.clientWidth){
        var fitted=Math.max(base*.5,base*(available/ribbon.scrollWidth));
        ribbon.style.fontSize=fitted+'px';
      }
    });
  }
  text.addEventListener('input',scale);
  if(width)width.addEventListener('change',scale);
  if(position)position.addEventListener('change',scale);
  if(symbol)symbol.addEventListener('change',scale);
  if(font)font.addEventListener('change',scale);
  window.addEventListener('resize',scale);
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(scale);
  scale();
});
